import React, { useMemo } from "react";

import { UserRequestedApplications } from "../../../store";
import { ApplicationList, ApplicationListItemModel } from "./ApplicationList";

interface ExistingApplicationsRequestedProps {
	cancelExistingAppRequest: (appId: string) => void;
	cancelExistingAppRequestLoading: boolean;
	existingAppRequestRemoving: string;
	userLoading: boolean;
	existingAppRequests?: UserRequestedApplications[];
}

const ExistingApplicationsRequested: React.FC<ExistingApplicationsRequestedProps> = ({
	existingAppRequests,
	cancelExistingAppRequest,
	cancelExistingAppRequestLoading,
	existingAppRequestRemoving,
	userLoading,
}) => {
	const items = useMemo<ApplicationListItemModel[]>(() => {
		return (existingAppRequests ?? []).map((app) => ({
			id: app.application,
			title: app["friendly-name"] || app.application,
			onDelete: () => cancelExistingAppRequest(app.application),
			isLoading: (cancelExistingAppRequestLoading || userLoading) && existingAppRequestRemoving === app.application,
		}));
	}, [
		existingAppRequests,
		cancelExistingAppRequest,
		cancelExistingAppRequestLoading,
		existingAppRequestRemoving,
		userLoading,
	]);

	return (
		<ApplicationList
			listId="existing-application-requests"
			items={items}
			emptyTitle="No application requests"
			emptyBody="You haven't requested access for any application yet."
		/>
	);
};

export default ExistingApplicationsRequested;
